<section class="shared-confirm-button">
  <ion-button
    [disabled]="isLoading || isDisabled"
    [color]="color"
    fill="outline"
    (click)="onConfirm()"
  >
    {{ confirmButtonTextKey | translate }}
    @if (isLoading) {
      <ion-spinner data-testid="spinner" color="primary"></ion-spinner>
    }
  </ion-button>
</section>
